export interface FAQItem {
  question: string;
  answer: string;
}

export const homepageFAQs: FAQItem[] = [
  {
    question: '91com是什么平台？',
    answer: '91com是一个综合性在线服务平台，为用户提供丰富的数字内容和便捷的在线功能。平台涵盖多个领域，致力于为用户打造安全、高效、优质的使用体验。自上线以来，91com已累计服务超过500万用户，获得了广泛的好评与信赖。',
  },
  {
    question: '如何找到91com最新官方入口？',
    answer: '您可以通过本页面（91com官方平台）获取91com的最新官方入口地址。我们建议您将本页面加入浏览器收藏夹，以便随时获取最新信息。同时，您也可以关注91com官方社交媒体账号，获取第一手的入口更新通知。',
  },
  {
    question: '91com注册需要什么条件？',
    answer: '注册91com账号非常简单，您只需要准备一个有效的手机号码即可。访问91com官网，点击注册按钮，按照页面提示输入手机号码、设置密码并完成短信验证，大约1-2分钟即可完成注册。注册完全免费。',
  },
  {
    question: '91com账号安全如何保障？',
    answer: '91com平台采用业界领先的安全技术保护用户账号，包括SSL加密传输、多重身份验证、异常登录检测等。我们建议用户设置强密码、绑定安全手机和邮箱、开启双重验证，以进一步提升账号安全性。',
  },
  {
    question: '忘记91com密码怎么办？',
    answer: '如果您忘记了91com的登录密码，可以在登录页面点击"忘记密码"，通过绑定的手机号码接收验证码来重置密码。如果您同时无法使用绑定手机，请联系91com官方客服进行人工身份验证和密码重置。',
  },
  {
    question: '91com有哪些核心功能？',
    answer: '91com平台提供内容浏览、智能搜索、分类导航、个人收藏、评论互动、社区交流、个性化推荐等丰富的核心功能。平台还支持PC端和移动端访问，并提供官方APP下载，满足用户不同场景下的使用需求。',
  },
  {
    question: '91com平台是否免费使用？',
    answer: '91com平台的基础功能完全免费，用户可以免费注册账号、浏览内容、参与社区互动。部分高级功能或专属内容可能属于会员权益，用户可根据自身需求选择是否升级。平台始终保证基础功能的免费可用性。',
  },
  {
    question: '如何联系91com官方客服？',
    answer: '您可以通过以下方式联系91com官方客服：在91com官网或APP内使用在线客服功能、发送邮件至官方客服邮箱、拨打官方客服热线。客服团队提供7×24小时全天候服务，随时为您解答疑问。',
  },
];